import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import { encryptToken } from "../../../Services/Encryption/EncryptionParams";
import ActivitesForm from "./ActivitesForm";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { DeleteActivities } from "../../../Redux/Reducers/ReportStage/Activities";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/Api/ApiServices";

const ActivitiesTable = (props) => {
  const AddActivitesResult = useSelector(
    (state) => state.Activities.AddActivities
  );
  const UpdateActivitesResult = useSelector(
    (state) => state.Activities.UpdateActivities
  );
  const [jsonData, setJsonData] = useState({});

  const [activitiesObjectivesId, setactivitiesObjectivesId] = useState(null);

  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "activitiesName",
      ShowStatus: true,
      NmaeColumn: "النشاط",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);

        setactivitiesObjectivesId(objects.activitiesObjectivesId);
        setPopUpBodyStatus(true);

        console.log(objects, "objects");
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: !props.disabled,
      InitialScreeningAssessment: true,
    },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        var activitiesObjectivesId = objects.activitiesObjectivesId;

        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteActivities({
                activitiesObjectivesId: activitiesObjectivesId,
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !props.disabled,
      InitialScreeningAssessment: true,
      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <ActivitesForm reportId={props.reportId} />,

    title: "النشاط",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <ActivitesForm
        Action="edit"
        activitiesObjectivesId={activitiesObjectivesId}
        reportId={props.reportId}
      />
    ),

    title: "الانشطة",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [
    props.roundActive,
    props.fields,
    AddActivitesResult,
    UpdateActivitesResult,
  ]);
console.log(!props.disabled,"ssssssssssssdwdwdwd");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        // RequestsManagerValue={true}
        AllValueAction={true}
        uniqueValue={"taskId"}
        valueButtonAction={"taskId"}
        URL={`api/Activities/GetListActivities`}
        UrlBody={{
          reportId: props.reportId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.disabled}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        uniqeKeyNameRedux={"tasksList"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default ActivitiesTable;
